import { Directive, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';

@Directive({
    selector: '[appClickOutside]',
    standalone: false
})
export class ClickOutsideDirective {
  @Input() enableClickInsideElement: HTMLElement;

  @Output() clickOutside = new EventEmitter();

  constructor(private readonly elementRef: ElementRef) { }

  @HostListener('document:click', ['$event.target'])
  public onClick(target) {
    if (this.enableClickInsideElement) {
      const clickedInsideParentElement = this.enableClickInsideElement.contains(target);
      if (clickedInsideParentElement) {
        const clickedInside = this.elementRef.nativeElement.contains(target);
        if (!clickedInside) {
          this.clickOutside.emit();
        }
      } else {
        return;
      }
    } else {
      const clickedInside = this.elementRef.nativeElement.contains(target);
      if (!clickedInside) {
        this.clickOutside.emit();
      }
    }
  }

}
